import React from 'react';

import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import ManagePageHeader from 'components/ManagePageHeader/ManagePageHeader';
import TextButton from 'components/TextButton/TextButton';
import action_library_messages from 'messages/action_library_messages';
import { useHelpDialogContext } from 'reactContext/HelpDialogContext/HelpDialogContext';
import PATHS from 'router/PATHS';

import ActionLibraryInstanceForm from './ActionLibraryInstanceForm';

const ActionLibraryInstanceCreatePage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { showHelpDialog } = useHelpDialogContext();

  const handleNavigation = () => {
    history.push(PATHS.ACTION_LIBRARY_INSTANCE);
  };

  const handleShowHelp = () => {
    showHelpDialog({
      title: t(action_library_messages.instance.help.title),
      body: t(action_library_messages.instance.help.body),
    });
  };

  return (
    <Container>
      <ManagePageHeader
        backButton
        onBack={handleNavigation}
        rightAdornment={
          <TextButton key='introduction' onClick={handleShowHelp}>
            {t(action_library_messages.instance.form.how_does_it_work)}
          </TextButton>
        }
        subtitle={t(action_library_messages.instance.create_subtitle)}
      >
        {t(action_library_messages.instance.create_title)}
      </ManagePageHeader>

      <ActionLibraryInstanceForm />
    </Container>
  );
};

export default ActionLibraryInstanceCreatePage;
